import { useEffect } from 'react';
import { ScheduleQueries } from '@frontend/api-schedule';
import { useQuickFillRecipientShallowStore } from '../store';

export const useQuickFillRecipients = (locationId: string, searchTerm: string) => {
  const { setFilteredCount, clearFilteredCount } = useQuickFillRecipientShallowStore(
    'setFilteredCount',
    'clearFilteredCount'
  );

  // Fetch Quick Fill Recipients - Paginated
  const infiniteQuery = ScheduleQueries.useQuickFillRecipientsInfiniteQuery(locationId, searchTerm);
  const queryCount = infiniteQuery.data?.pages?.[0].totalCount || 0;

  useEffect(() => {
    // Do not update the filtered count if the query is still loading or fetching
    if (infiniteQuery.isFetching) {
      return;
    }

    if (!searchTerm) {
      clearFilteredCount(locationId);
      return;
    }

    if (queryCount !== undefined) {
      setFilteredCount(locationId, queryCount);
    }
  }, [infiniteQuery?.isLoading, infiniteQuery?.isFetching, queryCount]);

  return infiniteQuery;
};
